import React from 'react'

const VDI_Color = () => {
  return (
    <svg id="Layer_1" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 400 400">
      <path
        className="st0"
        d="M356.5,200.4v-40C357.4,73.1,287.4,1.5,200.1.4,112.8,1.5,42.9,73.1,43.7,160.4v40h-13v26.8h52.2v160c-.1,7.2,5.7,13.2,12.9,13.3,0,0,0,0,0,0h208.5c7.2,0,13-6,13-13.2,0,0,0,0,0,0v-160h52.2v-26.8h-13.1ZM291.3,373.8H108.9v-129.1c6.2,4.9,11.5,10.8,15.7,17.6,10.4,14.3,23.4,32,49.5,32s36.4-16.7,51.5-34.3c16.9-19.9,34.4-40.2,65.7-44.7v158.5ZM291.3,188.1c-43.2,4.8-67.4,32.7-85.4,53.8-13.3,15.6-22,25.2-31.8,25.2s-18.7-7.7-29.1-21.3c-8.2-14-21.1-24.7-36.5-30.2v-41.8h182.8v14.3ZM330.1,200.4h-12.7v-40c.1-7.3-5.7-13.3-13-13.4,0,0,0,0,0,0H95.9c-7.3.1-13.1,6.1-13,13.4,0,0,0,0,0,0v40h-13.4v-40c-.8-72.9,57.7-132.6,130.6-133.3,0,0,0,0,0,0,72.8.9,131.1,60.6,130.3,133.3l-.4,40Z"
      />
      <path className="st0" d="M272.2,286.2h-23v59.1h23v-59.1Z" />
      <path className="st0" d="M239,286.2h-22.8v59.1h22.8v-59.1Z" />
    </svg>
  )
}
export default VDI_Color
